import React from 'react';
import { graphql, compose } from 'react-apollo';
import { Redirect } from 'react-router-dom';
import Spinner from '../../spinner/spinner';
import { Button, Form, Row, Col } from 'antd';
import FaqAnswerForm from './faqAnswerForm';
import { getFaqAnswer } from "./queries/getFaqAnswer";
import { updateFaqAnswer } from "./mutations/updateFaqAnswer";

const onCancelClick = (history) => { history.push("/dashboard/admin/faqAnswersList/") };

class EditFaqAnswer extends React.Component {
  mutationParams = () => {
    return {
      variables: {
        input: {
          ...this.props.form.getFieldsValue(),
          id: parseInt(this.faqAnswer.id)
        }
      }
    }
  };

  redirectTo = (data) => {
    this.props.history.push(`/dashboard/admin/faqAnswersList?faqAnswer=${data.updateFaqAnswer.faqAnswer.id}`);
  };

  get faqAnswer() {
    return this.props.data.faqAnswer;
  }

  formControls(loading) {
    return (
      <Row type="flex" justify="end" className="align-right">
        <Col xs={{ span: 24, order: 1 }} md={{ span: 6, order: 0 }}>
          <Button onClick={() => { onCancelClick(this.props.history) }} className="faq-answers-list__control">
            Cancel Updates
          </Button>
        </Col>
        <Col xs={{ span: 24, order: 0 }} md={{ span: 6, offset: 1, order: 1 }}>
          <Button type="primary" htmlType="submit" className="faq-answers-list__control" loading={loading}>
            Save Updates
          </Button>
        </Col>
      </Row>
    );
  }

  render() {
    if (this.props.data.loading) {
      return (
        <Spinner/>
      );
    } else if (this.faqAnswer) {
      return (
        <FaqAnswerForm {...this.props } faqAnswer={this.faqAnswer}
                             formControls={this.formControls.bind(this)}
                             mutationParams={this.mutationParams}
                             redirectTo={this.redirectTo}
                             onSubmit={this.onSubmit}/>
      );
    } else {
      return <Redirect to="/404" />;
    }
  }
}

export default Form.create()(
  compose(
    graphql(getFaqAnswer, {
      options: ({ match }) => ({
        variables: { faqAnswerId: parseInt(match.params.faqAnswerId, 10) },
        fetchPolicy: 'cache-and-network'
      })
    }),
    graphql(updateFaqAnswer)
  )(EditFaqAnswer)
);



// WEBPACK FOOTER //
// ./src/components/pages/faqAnswers/editFaqAnswer.js